export function generateSimpleImageMapFor(folderName) {
	return {
		'0': require(`@/assets/img/${folderName}/0.png`),
		'1': require(`@/assets/img/${folderName}/1.png`),
		'2': require(`@/assets/img/${folderName}/2.png`),
		'3': require(`@/assets/img/${folderName}/3.png`),
		'4': require(`@/assets/img/${folderName}/4.png`),
		'5': require(`@/assets/img/${folderName}/5.png`),
		'6': require(`@/assets/img/${folderName}/6.png`),
		'7': require(`@/assets/img/${folderName}/7.png`),
		'8': require(`@/assets/img/${folderName}/8.png`),
		'9': require(`@/assets/img/${folderName}/9.png`)
	};
}

export function generateImageMapFor(folderName) {
	return {
		'0': require(`@/assets/img/${folderName}/0.png`),
		'1': require(`@/assets/img/${folderName}/1.png`),
		'2': require(`@/assets/img/${folderName}/2.png`),
		'3': require(`@/assets/img/${folderName}/3.png`),
		'4': require(`@/assets/img/${folderName}/4.png`),
		'5': require(`@/assets/img/${folderName}/5.png`),
		'6': require(`@/assets/img/${folderName}/6.png`),
		'7': require(`@/assets/img/${folderName}/7.png`),
		'8': require(`@/assets/img/${folderName}/8.png`),
		'9': require(`@/assets/img/${folderName}/9.png`),
		'00': require(`@/assets/img/${folderName}/00.png`),
		'01': require(`@/assets/img/${folderName}/01.png`),
		'02': require(`@/assets/img/${folderName}/02.png`),
		'03': require(`@/assets/img/${folderName}/03.png`),
		'04': require(`@/assets/img/${folderName}/04.png`),
		'05': require(`@/assets/img/${folderName}/05.png`),
		'06': require(`@/assets/img/${folderName}/06.png`),
		'07': require(`@/assets/img/${folderName}/07.png`),
		'08': require(`@/assets/img/${folderName}/08.png`),
		'09': require(`@/assets/img/${folderName}/09.png`),
		'10': require(`@/assets/img/${folderName}/10.png`),
		'11': require(`@/assets/img/${folderName}/11.png`),
		'12': require(`@/assets/img/${folderName}/12.png`),
		'13': require(`@/assets/img/${folderName}/13.png`),
		'14': require(`@/assets/img/${folderName}/14.png`),
		'15': require(`@/assets/img/${folderName}/15.png`),
		'16': require(`@/assets/img/${folderName}/16.png`),
		'17': require(`@/assets/img/${folderName}/17.png`),
		'18': require(`@/assets/img/${folderName}/18.png`),
		'19': require(`@/assets/img/${folderName}/19.png`),
		'20': require(`@/assets/img/${folderName}/20.png`),
		'21': require(`@/assets/img/${folderName}/21.png`),
		'22': require(`@/assets/img/${folderName}/22.png`),
		'23': require(`@/assets/img/${folderName}/23.png`),
		'24': require(`@/assets/img/${folderName}/24.png`),
		'25': require(`@/assets/img/${folderName}/25.png`),
		'26': require(`@/assets/img/${folderName}/26.png`),
		'27': require(`@/assets/img/${folderName}/27.png`),
		'28': require(`@/assets/img/${folderName}/28.png`),
		'29': require(`@/assets/img/${folderName}/29.png`),
		'30': require(`@/assets/img/${folderName}/30.png`),
		'31': require(`@/assets/img/${folderName}/31.png`),
		'32': require(`@/assets/img/${folderName}/32.png`),
		'33': require(`@/assets/img/${folderName}/33.png`),
		'34': require(`@/assets/img/${folderName}/34.png`),
		'35': require(`@/assets/img/${folderName}/35.png`),
		'36': require(`@/assets/img/${folderName}/36.png`),
		'37': require(`@/assets/img/${folderName}/37.png`),
		'38': require(`@/assets/img/${folderName}/38.png`),
		'39': require(`@/assets/img/${folderName}/39.png`),
		'40': require(`@/assets/img/${folderName}/40.png`),
		'41': require(`@/assets/img/${folderName}/41.png`),
		'42': require(`@/assets/img/${folderName}/42.png`),
		'43': require(`@/assets/img/${folderName}/43.png`),
		'44': require(`@/assets/img/${folderName}/44.png`),
		'45': require(`@/assets/img/${folderName}/45.png`),
		'46': require(`@/assets/img/${folderName}/46.png`),
		'47': require(`@/assets/img/${folderName}/47.png`),
		'48': require(`@/assets/img/${folderName}/48.png`),
		'49': require(`@/assets/img/${folderName}/49.png`),
		'50': require(`@/assets/img/${folderName}/50.png`),
		'51': require(`@/assets/img/${folderName}/51.png`),
		'52': require(`@/assets/img/${folderName}/52.png`),
		'53': require(`@/assets/img/${folderName}/53.png`),
		'54': require(`@/assets/img/${folderName}/54.png`),
		'55': require(`@/assets/img/${folderName}/55.png`),
		'56': require(`@/assets/img/${folderName}/56.png`),
		'57': require(`@/assets/img/${folderName}/57.png`),
		'58': require(`@/assets/img/${folderName}/58.png`),
		'59': require(`@/assets/img/${folderName}/59.png`),
		'60': require(`@/assets/img/${folderName}/60.png`),
		'61': require(`@/assets/img/${folderName}/61.png`),
		'62': require(`@/assets/img/${folderName}/62.png`),
		'63': require(`@/assets/img/${folderName}/63.png`),
		'64': require(`@/assets/img/${folderName}/64.png`),
		'65': require(`@/assets/img/${folderName}/65.png`),
		'66': require(`@/assets/img/${folderName}/66.png`),
		'67': require(`@/assets/img/${folderName}/67.png`),
		'68': require(`@/assets/img/${folderName}/68.png`),
		'69': require(`@/assets/img/${folderName}/69.png`),
		'70': require(`@/assets/img/${folderName}/70.png`),
		'71': require(`@/assets/img/${folderName}/71.png`),
		'72': require(`@/assets/img/${folderName}/72.png`),
		'73': require(`@/assets/img/${folderName}/73.png`),
		'74': require(`@/assets/img/${folderName}/74.png`),
		'75': require(`@/assets/img/${folderName}/75.png`),
		'76': require(`@/assets/img/${folderName}/76.png`),
		'77': require(`@/assets/img/${folderName}/77.png`),
		'78': require(`@/assets/img/${folderName}/78.png`),
		'79': require(`@/assets/img/${folderName}/79.png`),
		'80': require(`@/assets/img/${folderName}/80.png`),
		'81': require(`@/assets/img/${folderName}/81.png`),
		'82': require(`@/assets/img/${folderName}/82.png`),
		'83': require(`@/assets/img/${folderName}/83.png`),
		'84': require(`@/assets/img/${folderName}/84.png`),
		'85': require(`@/assets/img/${folderName}/85.png`),
		'86': require(`@/assets/img/${folderName}/86.png`),
		'87': require(`@/assets/img/${folderName}/87.png`),
		'88': require(`@/assets/img/${folderName}/88.png`),
		'89': require(`@/assets/img/${folderName}/89.png`),
		'90': require(`@/assets/img/${folderName}/90.png`),
		'91': require(`@/assets/img/${folderName}/91.png`),
		'92': require(`@/assets/img/${folderName}/92.png`),
		'93': require(`@/assets/img/${folderName}/93.png`),
		'94': require(`@/assets/img/${folderName}/94.png`),
		'95': require(`@/assets/img/${folderName}/95.png`),
		'96': require(`@/assets/img/${folderName}/96.png`),
		'97': require(`@/assets/img/${folderName}/97.png`),
		'98': require(`@/assets/img/${folderName}/98.png`),
		'99': require(`@/assets/img/${folderName}/99.png`)
	};
}
